// 合計グリッド(totaltype パネル)の ref 管理と行反映をまとめる。
// 加工指示・品番マスタで同一実装のため共有する。
export function createTotalGridAccessors(deps) {
    const {
        isEmpty,
        DicVal,
        createRef,
        totalgriddataRefs,
        totalgridcolRefs,
        totalgridapiRefs
    } = deps;

    function totalRefKey(panel) {
        return String(DicVal(panel, 'id', '')) + '_' + String(DicVal(panel, 'totaltype', ''));
    }
    function ensureTotalDataRef(panel) {
        const key = totalRefKey(panel);
        if (isEmpty(totalgriddataRefs.current[key])) totalgriddataRefs.current[key] = { current: null };
        return totalgriddataRefs.current[key];
    }
    function ensureTotalColRef(panel) {
        const key = totalRefKey(panel);
        if (isEmpty(totalgridcolRefs.current[key])) totalgridcolRefs.current[key] = { current: [] };
        if (!Array.isArray(totalgridcolRefs.current[key].current)) totalgridcolRefs.current[key].current = [];
        return totalgridcolRefs.current[key];
    }
    function ensureTotalApiRef(panel) {
        const key = totalRefKey(panel);
        if (isEmpty(totalgridapiRefs.current[key])) totalgridapiRefs.current[key] = createRef();
        return totalgridapiRefs.current[key];
    }
    function SetTotalGridApi(panel, api) {
        if (isEmpty(panel)) return;
        ensureTotalApiRef(panel).current = api;
    }
    function TotalGridApi(panel) {
        if (isEmpty(panel)) return null;
        return ensureTotalApiRef(panel).current;
    }
    // ag-grid のバージョン差を吸収して合計行を即時反映する。
    function applyTotalRowsNow(totalPanel, rows) {
        const api = TotalGridApi(totalPanel);
        if (isEmpty(api)) return;
        const nextRows = Array.isArray(rows) ? rows : [];
        if (typeof api.setGridOption === 'function') {
            api.setGridOption('rowData', nextRows);
        } else if (typeof api.setRowData === 'function') {
            api.setRowData(nextRows);
        }
        if (typeof api.refreshCells === 'function') api.refreshCells({ force: true });
        if (typeof api.redrawRows === 'function') api.redrawRows();
    }
    function onFirstTotalDataRendered(param, totalPanel) {
        if (isEmpty(param) || isEmpty(param.api) || isEmpty(totalPanel)) return;
        SetTotalGridApi(totalPanel, param.api);
        const rows = Array.isArray(ensureTotalDataRef(totalPanel).current) ? ensureTotalDataRef(totalPanel).current : [];
        applyTotalRowsNow(totalPanel, rows);
    }

    return {
        totalRefKey,
        ensureTotalDataRef,
        ensureTotalColRef,
        ensureTotalApiRef,
        SetTotalGridApi,
        TotalGridApi,
        applyTotalRowsNow,
        onFirstTotalDataRendered
    };
}
